import { render } from "./index1.vue?vue&type=template&id=5641bf8f&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"

import "./index1.vue?vue&type=style&index=0&id=5641bf8f&scoped=true&lang=css"
import "./index1.vue?vue&type=style&index=1&id=5641bf8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5641bf8f"]])

export default __exports__